import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;
declare const isClientVend: string;

export interface VendProgressChannelData {
    message: string;
    progress: number;
    inProgress: boolean;
    success: boolean;
}

class VendProgressUpdate {
    vendProgressUpdateChannel: any;
    noDiscrepancies = false;

    constructor() {
        var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;
        var isClientVendd = (typeof isClientVend === "undefined") ? false : isClientVend;

        if(isClientVendd == 'true'){
            this.vendProgressUpdateChannel = App.cable.subscriptions.create(
                {
                    channel: "Vend::SyncProgressChannel",
                    tenant_code: x,
                    roomId: `vend_sync_${x}`
                },
                {
                    connected() {
                        console.log("Connected to Vend Progress Update Channel");
                    },
                    disconnected() {
                        console.log("Disconnected to Vend Progress Update Channel");
                    },
                    received: (data: any) => this.updateProgress(data)
                }
            );
        }

    }

    disablePreviewAndSyncButtons() {
        $(".vendSyncBtn").attr('disabled', 'disabled');
        $(".doVendSyncBtn").attr('disabled', 'disabled');
        $(".previewSyncBtn").attr('disabled', 'disabled').removeAttr('href');
    }

    updateProgress(data: VendProgressChannelData) {
        console.log(data);
        $("#vend_sync").show();
        $("#vend_sync_btn").hide();
        $("#last_update").hide();
        $("#vend_sync_progress").text(data.message);
        $(".progress-bar").css("width", `${data.progress}%`);
        $("#vendProgressLabel").text(`${data.progress}%`)
        $(".currentStatusDesc_Category").text(`${data.message}`)
        if (data.inProgress && data.message != "Matching 100%, no discrepancies detected") {
            this.noDiscrepancies = false;
        }
        if (data.message == "Matching 100%, no discrepancies detected") {
            this.noDiscrepancies = true;
            $(".progress-spin").hide();
            $(".fail-img").hide();
            $('.success-img').removeClass("hide");
            $(".success-img").show();
            this.disablePreviewAndSyncButtons();
            $(".currentStatusDesc_Category").text('No discrepancies found');
            return;
        }
        var bat = $(".categ_vend_sync").length == 1 || $(".sync_to_vend").length == 1
        if (!data.inProgress && data.success && bat){
            $(".progress-spin").hide();
            $(".fail-img").hide();
            $(".doSyncBtn").hide();
            $(".vendSyncBtn").show();
            $('.success-img').removeClass("hide");
            $(".success-img").show();
            if (this.noDiscrepancies) {
                this.disablePreviewAndSyncButtons();
                $(".currentStatusDesc_Category").text('No discrepancies found');
                return;
            }
            $(".vendSyncBtn").removeAttr('disabled')
            $(".doVendSyncBtn").removeAttr('disabled')
            $(".previewSyncBtn").removeAttr('disabled')
            $(".currentStatusDesc_Category").text('Synchronization preview complete')
        }
        if (!data.inProgress && data.success && !bat) {
            this.refresh();
// need to check
            $("#vend_sync_btn").show();
            $("#last_update").show();

        }
        if (!data.success) {
            this.refresh();
        }
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("items", () => {
        const ts = new VendProgressUpdate();
    });
    InitPage("compare_v2", () => {
        const t = new VendProgressUpdate();
    });
    InitPage("print_v2", () => {
        const t = new VendProgressUpdate();
    });
}
